module.exports = __webpack_public_path__ + "img/olas_azules.156aba3a.png";